import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/button-icons/tick-icon-white.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-566d1e66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "progress-modal",
  "data-test": "indicator-progress-modal"
}
const _hoisted_2 = { class: "progress-modal-content scale-up-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "progress-modal-body" }
const _hoisted_5 = { class: "progress-steps" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: "completed step"
}
const _hoisted_7 = { class: "circle-text" }

import type { Step } from "./indicator-steps";


export default /*#__PURE__*/_defineComponent({
  __name: 'indicator-progress-modal',
  props: {
    showModal: { type: Boolean },
    modalTitle: {},
    modalMessage: {},
    currentStep: {},
    steps: {}
  },
  emits: ["on-next-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function onNextClick() {
  emit("on-next-click");
}

return (_ctx: any,_cache: any) => {
  return (props.showModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(props.modalTitle), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(props.modalMessage), 1),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "step",
                  style: _normalizeStyle({ flex: index === _ctx.steps.length - 1 ? 0 : 1 })
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["circle", { completed: index < _ctx.currentStep, current: index === _ctx.currentStep }])
                  }, [
                    (index < _ctx.currentStep)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(step.title), 1)
                  ], 2),
                  (index !== _ctx.steps.length - 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["line", {
                thick: index < _ctx.currentStep && index < _ctx.steps.length - 1,
                dashed: index === _ctx.currentStep || index > _ctx.currentStep,
              }])
                      }, null, 2))
                    : _createCommentVNode("", true)
                ], 4))
              }), 128))
            ])
          ]),
          _createElementVNode("div", { class: "center-flex next-button" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: onNextClick
            }, "Next")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})